// src/component/Banner.js
import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import coder         from "../assets/img/files.png";
import qrcode        from "../assets/img/qrcode.png";
import playstoreIcon from "../assets/img/playstor.svg";
import appstoreIcon  from "../assets/img/aple.svg";
import amazonIcon    from "../assets/img/amazon.svg";
import { ArrowRightCircle } from "react-bootstrap-icons";
import "animate.css";
import TrackVisibility from "react-on-screen";

const ROTATING_WORDS = [
  "Exit Exams",
  "12 National Exams",
  "Entrance Exams",
  "Professional Exams",
  "Various Services",
];
const PERIOD = 2000;

export const Banner = () => {
  const [loopNum,   setLoopNum]   = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text,      setText]      = useState("");
  const [delta,     setDelta]     = useState(300 - Math.random() * 100);

  const handleConnectClick = () => {
    document.getElementById("apply")?.scrollIntoView({ behavior: "smooth" });
  };

  const handleGetPremiumClick = () => {
    document.getElementById("pricing")?.scrollIntoView({ behavior: "smooth" });
  };

  // Typewriter tick
  const tick = () => {
    const i        = loopNum % ROTATING_WORDS.length;
    const fullText = ROTATING_WORDS[i];
    const updated  = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updated);
    if (isDeleting) setDelta((d) => d / 2);

    if (!isDeleting && updated === fullText) {
      setIsDeleting(true);
      setDelta(PERIOD);
    } else if (isDeleting && updated === "") {
      setIsDeleting(false);
      setLoopNum((n) => n + 1);
      setDelta(500);
    }
  };

  useEffect(() => {
    const ticker = setInterval(tick, delta);
    return () => clearInterval(ticker);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text]);

  useEffect(() => {
    const container = document.querySelector(".droplets");
    if (!container) return;
    for (let i = 0; i < 7; i++) {
      const d = document.createElement("div");
      d.classList.add("droplet");
      d.style.left              = `${Math.random() * 100}vw`;
      d.style.animationDelay    = `${Math.random() * 2}s`;
      d.style.animationDuration = `${Math.random() * 6 + 4}s`;
      container.appendChild(d);
    }
  }, []);

  return (
    <section className="banner" id="home" style={bannerStyles.section}>
      {/* Ambient orbs */}
      <div style={{ ...bannerStyles.orb, width: 400, height: 400, background: "#31b3ba", top: -100, right: -100 }} />
      <div style={{ ...bannerStyles.orb, width: 300, height: 300, background: "#a855f7", bottom: 0, left: -80 }} />

      <Container style={{ position: "relative", zIndex: 2 }}>
        <Row className="align-items-center">

          {/* ── Left column ─────────────────────────────── */}
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__fadeInLeft" : ""}>
                  <div className="droplets" />

                  {/* Brand */}
                  <div style={bannerStyles.brandBadge}>
                    <span style={{ color: "#31b3ba", marginRight: 6 }}>✦</span>
                    Ethiopia's #1 Exam Prep Platform
                  </div>

                  <h1 style={bannerStyles.title}>
                    Ethio Exam{" "}
                    <span style={bannerStyles.gradientText}>Mastery</span>
                  </h1>

                  {/* Typewriter */}
                  <div style={bannerStyles.typewriterRow}>
                    <span style={bannerStyles.typewriterLabel}>Preparing for</span>
                    <span style={bannerStyles.typewriterText}>
                      {text}
                      <span style={bannerStyles.cursor}>|</span>
                    </span>
                  </div>

                  {/* Description card */}
                  <div style={bannerStyles.descCard}>
                    <div style={bannerStyles.descAccent} />
                    <p style={bannerStyles.descText}>
                      Your all-in-one platform for Ethiopian exam success. Expert-curated
                      questions, detailed answers, scholarships, training links, live events
                      and everything you need to excel — all in one place.
                    </p>
                  </div>

                  {/* Stats row */}
                  <div style={bannerStyles.statsRow}>
                    {[
                      { value: "10k+", label: "Students" },
                      { value: "300+", label: "Questions" },
                      { value: "4.8★", label: "Rating" },
                    ].map((s) => (
                      <div key={s.label} style={bannerStyles.statItem}>
                        <span style={bannerStyles.statValue}>{s.value}</span>
                        <span style={bannerStyles.statLabel}>{s.label}</span>
                      </div>
                    ))}
                  </div>

                  {/* CTA buttons */}
                  <div style={bannerStyles.ctaRow}>
                    <button onClick={handleGetPremiumClick} style={bannerStyles.primaryBtn}
                      onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-3px)"; e.currentTarget.style.boxShadow = "0 12px 40px rgba(49,179,186,0.55)"; }}
                      onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 6px 24px rgba(49,179,186,0.35)"; }}
                    >
                      🔓 Get Premium Access
                      <ArrowRightCircle size={20} style={{ marginLeft: 8 }} />
                    </button>
                    <button onClick={handleConnectClick} style={bannerStyles.secondaryBtn}
                      onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(255,255,255,0.1)"; e.currentTarget.style.transform = "translateY(-3px)"; }}
                      onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.transform = "translateY(0)"; }}
                    >
                      Learn & Teach
                      <ArrowRightCircle size={20} style={{ marginLeft: 8 }} />
                    </button>
                  </div>

                  {/* Download heading */}
                  <div style={bannerStyles.downloadSection}>
                    <div style={bannerStyles.downloadHeader}>
                      <div style={bannerStyles.downloadLine} />
                      <span style={bannerStyles.downloadTitle}>Download the App</span>
                      <div style={bannerStyles.downloadLine} />
                    </div>
                    <p style={{ color: "#9ca3af", fontSize: "0.88rem", margin: "0 0 18px" }}>
                      Available on all platforms
                    </p>

                    {/* Store icons */}
                    <div style={bannerStyles.storeRow}>
                      {[
                        { href: "https://play.google.com/store/apps/details?id=com.ethio.exam_mastery&hl=en", src: playstoreIcon, alt: "Play Store" },
                        { href: "https://www.amazon.com/dp/B0D3H836FZ/ref=apps_sf_sta", src: amazonIcon, alt: "Amazon Store" },
                        { href: "https://www.apple.com/app-store/", src: appstoreIcon, alt: "App Store" },
                      ].map((store) => (
                        <a key={store.alt} href={store.href} target="_blank" rel="noreferrer"
                          style={bannerStyles.storeLink}
                          onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.background = "rgba(49,179,186,0.15)"; }}
                          onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.background = "rgba(255,255,255,0.05)"; }}
                        >
                          <img src={store.src} alt={store.alt} style={{ width: 80, height: 48, objectFit: "contain" }} />
                        </a>
                      ))}
                    </div>

                    {/* QR code */}
                    <div style={bannerStyles.qrCard}>
                      <img
                        src={qrcode}
                        alt="QR Code to download the app"
                        style={{ width: "100%", maxWidth: 360, height: "auto", borderRadius: 10 }}
                      />
                      <p style={{ color: "#888", fontSize: "0.82rem", margin: "10px 0 0" }}>
                        Scan to download instantly
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </TrackVisibility>
          </Col>

          {/* ── Right column — illustration ─────────────── */}
          <Col xs={12} md={6} xl={5} className="p-0 d-none d-md-flex justify-content-center">
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={isVisible ? "animate__animated animate__zoomIn" : ""}
                  style={{ position: "relative" }}
                >
                  {/* Glowing ring behind the image */}
                  <div style={bannerStyles.imageGlow} />
                  <img
                    src={coder}
                    alt="Exam Mastery illustration"
                    style={bannerStyles.heroImage}
                  />
                </div>
              )}
            </TrackVisibility>
          </Col>

        </Row>
      </Container>

      <style>{`
        @keyframes blink {
          0%, 100% { opacity: 1; }
          50% { opacity: 0; }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-12px); }
        }
      `}</style>
    </section>
  );
};

// ── Styles ────────────────────────────────────────────────────────
const bannerStyles = {
  section: {
    padding: "80px 0 60px",
    background: "linear-gradient(160deg, #080f1e 0%, #0d1b33 60%, #080f1e 100%)",
    position: "relative",
    overflow: "hidden",
  },
  orb: {
    position: "absolute",
    borderRadius: "50%",
    filter: "blur(80px)",
    opacity: 0.08,
    pointerEvents: "none",
  },
  brandBadge: {
    display: "inline-flex",
    alignItems: "center",
    background: "rgba(49,179,186,0.08)",
    border: "1px solid rgba(49,179,186,0.3)",
    color: "#9ca3af",
    borderRadius: 50,
    padding: "5px 16px",
    fontSize: "0.78rem",
    fontWeight: 700,
    letterSpacing: "0.8px",
    marginBottom: 20,
  },
  title: {
    color: "#fff",
    fontSize: "clamp(2rem, 5vw, 3rem)",
    fontWeight: 900,
    margin: "0 0 20px",
    lineHeight: 1.1,
  },
  gradientText: {
    background: "linear-gradient(135deg, #31b3ba, #a855f7)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  },
  typewriterRow: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 10,
    marginBottom: 24,
  },
  typewriterLabel: {
    color: "#6b7280",
    fontSize: "1rem",
    fontWeight: 500,
  },
  typewriterText: {
    color: "#31b3ba",
    fontSize: "1.15rem",
    fontWeight: 800,
    minHeight: "1.5em",
  },
  cursor: {
    animation: "blink 0.9s infinite",
    marginLeft: 2,
    color: "#a855f7",
  },
  descCard: {
    position: "relative",
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: 14,
    padding: "18px 18px 18px 24px",
    marginBottom: 24,
    overflow: "hidden",
  },
  descAccent: {
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    width: 4,
    background: "linear-gradient(180deg, #31b3ba, #a855f7)",
    borderRadius: "4px 0 0 4px",
  },
  descText: {
    color: "#9ca3af",
    fontSize: "0.95rem",
    lineHeight: 1.7,
    margin: 0,
  },
  statsRow: {
    display: "flex",
    gap: 24,
    marginBottom: 28,
  },
  statItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  statValue: {
    color: "#31b3ba",
    fontSize: "1.4rem",
    fontWeight: 900,
    lineHeight: 1,
  },
  statLabel: {
    color: "#6b7280",
    fontSize: "0.75rem",
    fontWeight: 600,
    letterSpacing: "0.5px",
    marginTop: 3,
  },
  ctaRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 12,
    marginBottom: 36,
  },
  primaryBtn: {
    display: "flex",
    alignItems: "center",
    background: "linear-gradient(135deg, #31b3ba, #1a8f96)",
    color: "#fff",
    border: "none",
    padding: "14px 24px",
    borderRadius: 12,
    fontWeight: 800,
    fontSize: "1rem",
    cursor: "pointer",
    boxShadow: "0 6px 24px rgba(49,179,186,0.35)",
    transition: "all 0.25s ease",
  },
  secondaryBtn: {
    display: "flex",
    alignItems: "center",
    background: "transparent",
    color: "#fff",
    border: "1.5px solid rgba(255,255,255,0.2)",
    padding: "14px 24px",
    borderRadius: 12,
    fontWeight: 700,
    fontSize: "1rem",
    cursor: "pointer",
    transition: "all 0.25s ease",
  },
  downloadSection: {
    textAlign: "center",
  },
  downloadHeader: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    marginBottom: 6,
    justifyContent: "center",
  },
  downloadLine: {
    flex: 1,
    height: 1,
    maxWidth: 60,
    background: "rgba(255,255,255,0.1)",
  },
  downloadTitle: {
    color: "#9ca3af",
    fontSize: "0.9rem",
    fontWeight: 700,
    letterSpacing: "0.5px",
    whiteSpace: "nowrap",
  },
  storeRow: {
    display: "flex",
    justifyContent: "center",
    gap: 12,
    marginBottom: 20,
    flexWrap: "wrap",
  },
  storeLink: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(255,255,255,0.05)",
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: 12,
    padding: "10px 16px",
    textDecoration: "none",
    transition: "all 0.25s ease",
  },
  qrCard: {
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "center",
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: 16,
    padding: 16,
  },
  imageGlow: {
    position: "absolute",
    inset: -40,
    background: "radial-gradient(circle, rgba(49,179,186,0.15) 0%, transparent 70%)",
    borderRadius: "50%",
    pointerEvents: "none",
  },
  heroImage: {
    width: "100%",
    maxWidth: 420,
    height: "auto",
    animation: "float 4s ease-in-out infinite",
    position: "relative",
    zIndex: 1,
    filter: "drop-shadow(0 20px 60px rgba(49,179,186,0.25))",
  },
};